import type { HTMLAttributes } from 'react';
import './ContestTimer.css';

function fmt(sec: number): string {
  sec = Math.max(0, Math.floor(sec));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return (h > 0 ? `${pad(h)}:` : '') + `${pad(m)}:${pad(s)}`;
}

export interface ContestTimerProps extends HTMLAttributes<HTMLDivElement> {
  seconds: number;
  paused?: boolean;
  warnAt?: number;
  critAt?: number;
  label?: string;
}

export function ContestTimer({
  seconds = 0,
  paused = false,
  warnAt = 600,
  critAt = 120,
  label = 'remaining',
  style,
  ...rest
}: ContestTimerProps) {
  const state = paused
    ? 'paused'
    : seconds <= critAt
      ? 'critical'
      : seconds <= warnAt
        ? 'warning'
        : 'running';
  const dotColor = {
    running: 'var(--correct)',
    warning: 'var(--partial)',
    critical: 'var(--incorrect)',
    paused: 'var(--text-tertiary)',
  }[state];
  return (
    <div
      className={`uc-timer uc-timer--${state}`}
      style={style}
      role="timer"
      aria-label={`${fmt(seconds)} ${label}`}
      {...rest}
    >
      <span className="uc-timer__dot" style={{ background: dotColor }} />
      <span className="uc-timer__time">{fmt(seconds)}</span>
      <span className="uc-timer__label">{paused ? 'paused' : label}</span>
    </div>
  );
}
